import React from 'react';
import styled from 'styled-components';
import { LogOut, Users } from 'lucide-react';
import { useUser } from 'context/user/User';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';
import { leaveProducerPanel } from './enterProducerPanel';

/**
 * Faixa no topo do painel avisando que a pessoa está no painel de outro
 * produtor, como membro de equipe, e com saída à mão. Só aparece para quem
 * entrou por uma equipe.
 */
export default function ActingBanner() {
    const { user } = useUser();
    const actingAs = user?.acting_as;

    if (!actingAs) return null;

    const producerName = [user.first_name, user.last_name].filter(Boolean).join(' ');
    const teamNames = (actingAs.teams || []).map((team) => team.name).join(', ');

    return (
        <Banner role='status'>
            <Info>
                <Users size={16} color={panelAccent(colors.secondaryPurple)} aria-hidden='true' />
                <span>
                    Você está no painel de <strong>{producerName}</strong>
                    {teamNames ? <> como membro de <strong>{teamNames}</strong></> : null}.
                    {' '}Você só vê e faz o que a equipe liberou.
                </span>
            </Info>

            <Exit type='button' onClick={leaveProducerPanel}>
                <LogOut size={14} aria-hidden='true' />
                Sair do painel
            </Exit>
        </Banner>
    );
}

const Banner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 10px;
    background: ${panelAccentAlpha(colors.occasionalPurple, '12')};
    border: 1px solid ${panelAccentAlpha(colors.occasionalPurple, '30')};
    color: ${colors.nightDark};
    font-size: 13px;
    line-height: 1.4;

    @media screen and (min-width: ${breakpoints.sm}) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }
`;

const Info = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Exit = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    align-self: flex-start;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${colors.night}33;
    background: ${colors.neutralLight};
    color: ${colors.nightDark};
    font-size: 13px;
    cursor: pointer;

    &:hover {
        background: ${colors.night}0d;
    }
`;
